import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class EmployeeContractContribution  {
    _originalTypeClassName = "zERP.BO.EmployeeContractContribution";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
EmployeeContractContribution.translate = translateService;
}
this.Id = null;
this.SocialRegistryNumber = null;
this.InsuranceStartDate = null;
this.EmployerParameterValue = null;
this.EmployeeParameterValue = null;
this.EmployeeSubsidyValue = null;
this.EmployeeSubsidyStartDate = null;
this.EmployeeSubsidyEndDate = null;
this.EmployerSubsidyValue = null;
this.EmployerSubsidyStartDate = null;
this.EmployerSubsidyEndDate = null;
this.Disabled = false;
this.OverrideTemplate = false;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
SocialRegistryNumber:any;
InsuranceStartDate:any;
EmployerParameterValue:any;
EmployeeParameterValue:any;
EmployeeSubsidyValue:any;
EmployeeSubsidyStartDate:any;
EmployeeSubsidyEndDate:any;
EmployerSubsidyValue:any;
EmployerSubsidyStartDate:any;
EmployerSubsidyEndDate:any;
Disabled:any;
OverrideTemplate:any;
Rule:any;
SpecialInsuranceCase:any;
SICProfessionPackage:any;
static setRule = ($this, value) => {
var oldValue = $this.Rule;
$this.Rule = value;
if (value != null) {
}
}
static setSpecialInsuranceCase = ($this, value) => {
var oldValue = $this.SpecialInsuranceCase;
$this.SpecialInsuranceCase = value;
if (value != null) {
}
}
static setSICProfessionPackage = ($this, value) => {
var oldValue = $this.SICProfessionPackage;
$this.SICProfessionPackage = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}